export default __webpack_public_path__ + "static/media/evelyn_hu.eaba99c6.jpg";